module.exports = __webpack_public_path__ + "static/img/banner-about.808689e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/banner-about.jpg
// module id = ss2l
// module chunks = 0